import React, { Fragment, useEffect, useState } from "react";
import CommonCard from "../../common/components/CommonCard";
import { Box, Switch, Typography } from "@mui/material";
import theme from "../../theme";
import CommonFormField from "../../common/components/CommonFormField";
import moment from "moment";
import { setLoading } from "../../features/authSlice";
import { useDispatch, useSelector } from "react-redux";
import { showNotification } from "../../common/components/Notification/ToastifyNotification";
import { updateProjectResearch } from "../../api/resourceApi";
import CommonButton from "../../common/components/CommonButton";
import { ProjectStatus, ProjectTypeObj, UserTypeId } from "../../common/const";

const ProjectSetting = ({
    fromMentor,
    projectData,
    getProjectDetails
}) => {
    const dispatch = useDispatch();
    const { user } = useSelector((state) => state.auth);
    const [dueDate, setDueDate] = useState('');

    useEffect(() => {
        if (projectData?.end_date !== null) {
            setDueDate(moment(projectData?.end_date)?.format('YYYY-MM-DD'));
        } else {
            setDueDate('');
        }
    }, [projectData?.end_date]);

    return (
        <Fragment>
            <CommonCard
                borderRadius={2}
                headerContent={
                    <Fragment>
                        <Box
                            sx={{ padding: '13px 13px 0px 13px' }}
                        >
                            <Typography fontWeight={600}>Project Settings</Typography>
                        </Box>
                    </Fragment>
                }
                content={
                    <Fragment>
                        <Box
                            mt={2}
                            display="flex"
                            gap={2}
                            alignItems="center"
                            justifyContent="center"
                            sx={{
                                background: '#7A869126',
                                padding: 1
                            }}
                        >
                            <Box>
                                <Typography fontSize={14} fontWeight={600}>DCP Project</Typography>
                                <Typography fontSize={12} color={theme.palette.background.dark}>Use DCP Standard</Typography>
                            </Box>
                            <Switch
                                size="Medium"
                                checked={projectData?.project_source === ProjectTypeObj.ext}
                                disabled
                            />
                            <Box>
                                <Typography fontSize={14} fontWeight={600}>External Project</Typography>
                                <Typography fontSize={12} color={theme.palette.background.dark}>Use DCP Standard</Typography>
                            </Box>
                        </Box>
                        <Box p="10px 10px 0px 10px">
                            <CommonFormField
                                label="Project Deadline"
                                type="date"
                                name="deadline_date"
                                placeholder="Select Date"
                                value={dueDate}
                                disabled={fromMentor || user?.user_type_id !== UserTypeId.Student}
                                onChange={async (e) => {
                                    try {
                                        dispatch(setLoading({
                                            loading: true
                                        }));
                                        setDueDate(e.target.value)
                                        const response = await updateProjectResearch(projectData?.project_id, {
                                            end_date: new Date(e.target.value).toISOString()
                                        });
                                        if (response?.success) {
                                            showNotification('Project deadline date updated successfully', 'success');
                                            getProjectDetails();
                                            dispatch(setLoading({
                                                loading: false
                                            }));
                                        }
                                    } catch (err) {
                                        const errorMessage = err.response?.data?.errors?.[0]?.message || err.response?.data?.message || err?.response?.data?.error;
                                        showNotification(errorMessage, 'error');
                                        dispatch(setLoading({
                                            loading: false
                                        }));
                                    }
                                }}
                            />
                            {(user?.user_type_id === UserTypeId.Student && !fromMentor) &&
                                (<Box sx={{ float: 'right' }}>
                                    <CommonButton
                                        label={(projectData?.status === ProjectStatus.Enrolled || projectData?.status === ProjectStatus.Completed) ? "Start" : 'Complete'}
                                        width={(projectData?.status === ProjectStatus.Enrolled || projectData?.status === ProjectStatus.Completed) ? "90px" : "120px"}
                                        marginBottom="10px"
                                        marginTop="10px"
                                        height="35px"
                                        fontWeight={600}
                                        handleClick={async () => {
                                            try {
                                                dispatch(setLoading({
                                                    loading: true
                                                }));
                                                const response = await updateProjectResearch(projectData?.project_id, {
                                                    status: (projectData?.status === ProjectStatus.Enrolled || projectData?.status === ProjectStatus.Completed) ? ProjectStatus.InProgress : ProjectStatus.Completed
                                                });
                                                if (response?.success) {
                                                    showNotification('Project deadline date updated successfully', 'success');
                                                    getProjectDetails();
                                                    dispatch(setLoading({
                                                        loading: false
                                                    }));
                                                }
                                            } catch (err) {
                                                const errorMessage = err.response?.data?.errors?.[0]?.message || err.response?.data?.message || err?.response?.data?.error;
                                                showNotification(errorMessage, 'error');
                                                dispatch(setLoading({
                                                    loading: false
                                                }));
                                            }
                                        }}
                                    />
                                </Box>)}
                        </Box>
                    </Fragment>
                }
                paddingBottom="0px"
                padding="0px 0px 16px 0px"
                marginTop="15px"
            />
        </Fragment>
    )
}

export default ProjectSetting;